<template>
  <nav class="nav-bar sticky is-hidden-below-small">
    <div class="container">
      <ul>
        <li>
          <a :href="`${SalesUiUrl}/sales-area/sales`">
            {{ $gettext('Sales') }}
          </a>
        </li>
        <li v-if="hasCollaborations">
          <a :href="`${DittoDashboardUrl}/sales/collaborations`">
            {{ $gettext('Collaborations') }}
          </a>
        </li>
        <li v-if="isOnProPlanOrAbove">
          <a :href="`${ReportsUrl}/reports`">
            {{ $gettext('Reports') }}
          </a>
        </li>
        <li>
          <RouterLink to="/">
            {{ $gettext('Payouts') }}
          </RouterLink>
        </li>
        <li v-if="hasAdvances || advanceTransactions.length">
          <RouterLink to="/advances">
            {{ $gettext('Advances') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from 'vuex'
import { useGettext } from 'vue3-gettext'
import { useAdvanceStore } from '@/store'
import { getCookie } from '@/helpers/getCookie'

const { $gettext } = useGettext()
const { getters } = useStore()
const { advanceTransactions } = storeToRefs(useAdvanceStore())
const isOnProPlanOrAbove = computed(() => getters.isOnProPlanOrAbove)
const DittoDashboardUrl = process.env.VUE_APP_DASHBOARD_URL
const SalesUiUrl = process.env.VUE_APP_SALES_UI_URL
const ReportsUrl = process.env.VUE_APP_REPORTS_UI_URL
const hasAdvances = !!Number(getCookie('DittoMusic[hasAdvances]'))
const hasCollaborations = !!Number(getCookie('DittoMusic[hasCollaborations]'))
</script>
